import { Routes } from '@angular/router';
import { AdminComponent } from './admin/admin.component';
import { AdminDashboradComponent } from './admin/admin-dashborad/admin-dashborad.component';
import { AdminUsuariosComponent } from './admin/admin-usuarios/admin-usuarios.component';
import { adminGuard } from './guards/admin.guard';
import { AdminResolucionesComponent } from './admin/admin-resoluciones/admin-resoluciones.component';
import { LoginComponent } from './auth/login/login.component';
import { CallbackComponent } from './auth/callback/callback.component';
import { AdminResolucionesDetallesComponent } from './admin/admin-resoluciones-detalles/admin-resoluciones-detalles.component';
import { AdminConformidadesComponent } from './admin/admin-conformidades/admin-conformidades.component';
import { AdminProveedoresComponent } from './admin/admin-proveedores/admin-proveedores.component';
import { WebComponent } from './web/web.component';

export const routes: Routes = [
    // Ruta raíz redirige a login

    
    {
        path: '',
        component: WebComponent
    },
    
    // Rutas de autenticación
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'auth/callback',
        component: CallbackComponent
    },
    
    // Rutas del admin (protegidas)
    {
        path: 'admin',
        component: AdminComponent,
        canActivate: [adminGuard],
        children: [
            {
                path: '',
                component: AdminDashboradComponent
            },
            {
                path: 'usuarios',
                component: AdminUsuariosComponent
            },
            {
                path: 'proveedores',
                component: AdminProveedoresComponent
            },
            {
                path: 'bienes',
                component: AdminResolucionesComponent
            },
            {
                path: 'conformidades',
                component: AdminConformidadesComponent
            },
            {
                path: 'resoluciones/:id',
                component: AdminResolucionesDetallesComponent
            },
        ]
    },

    
    // Ruta wildcard (404)
    {
        path: '**',
        redirectTo: '/'
    }
];
